module.exports = __webpack_public_path__ + "img/section5-item1.20ed59c0.png";